<template>
  <div class="list__session-item">
    <!-- alert session interval -->
    <!-- <b-alert
      ref="alert__post-conflict"
      :show="conflict"
      variant="warning"
      class="mx-3"
    >
      Post schedule must be in the session interval
      <span v-if="editable" class="button__reschedule-post ml-1" @click="goToPostList()">
        Reschedule the conflicting post
      </span>
      <span> or </span>
      <span v-if="editable" class="button__reschedule-session" @click="goToEditSectionPage()">
        Reschedule session time
      </span>
    </b-alert> -->

    <div class="d-flex flex-row list__session-item text-second pr-3 text-wrap">
      <!-- column 2 -->
      <div class="d-flex flex-wrap flex-sm-nowrap p-0" :class="classRow">
        <div v-if="showCode" class="container__session text-center p-0 mr-sm-4 mb-3 mb-sm-0">
          <div class="text__session-title">Session ID</div>
          <!-- Session code -->
          <div class="text__session-id">
            {{ section.code }}
          </div>
          <!-- Session tag -->
          <!-- <div>
            <b-badge
              v-if="section.is_published"
              pill
              variant="neutral-success"
              class="text-success badge__tag-published-session"
            >
              Published
            </b-badge>
            <b-badge
              v-else
              pill
              variant="neutral-dark"
              class="text-dark badge__tag-draft-session"
            >
              Draft
            </b-badge>
          </div> -->
        </div>

        <!-- no schedule -->
        <!-- <div v-if="section.start_at === null">
          <router-link
            v-if="editable && showTitleAsLink"
            :to="feedPageRoute"
            class="text__session-time text-primary mb-2"
          >
            Not yet scheduled
          </router-link>

          <div
            v-else
            class="text__session-time mb-2"
          >Not yet scheduled</div>

          <div
            v-if="editable"
            class="button__set-session-time"
            @click="goToEditSectionPage()"
          >
            Set session times
          </div>
        </div> -->

        <!-- have schedule -->
        <div class="d-flex flex-wrap justify-content-end container__session-row">
          <!-- <div class="container__section-info pr-4">

            <div class="section__date-time">
              <router-link
                v-if="showTitleAsLink"
                :to="feedPageRoute"
                class="text__session-time text-primary mb-2"
              >
                {{ dateTimeStartToEnd }}
              </router-link>

              <div
                v-else
                class="text__session-time mb-2"
              >
                {{ dateTimeStartToEnd }}
              </div>

              <div class="
                  section__last-enrollment-time
                  text__session-last-enrollment-date text-dark
                  mb-2
                ">
                Last enrollment:
                {{
                  formatedDatetime(
                    section.last_enrollment,
                    "MMM D, YYYY hh:mma"
                  )
                }}
              </div>

              <div
                v-if="showTimezone"
                class="text__timezone text-dark"
              >
                {{ cityTimezone }} time
              </div>
            </div>

            <meeting-section
              :section="section"
              :number-of-online-meeting="learningUnit.number_of_online_meeting"
            />
          </div> -->

          <!-- column 3 -->
          <!-- <div
            v-if="showEnroll"
            class="pr-4"
          >
            <div v-if="section.max_learners !== null">
              <div class="mb-1 text__enrolled-slots">
                {{ enrollCount }}
              </div>
              <div class="text-dark">Enrolled</div>
            </div>
          </div> -->

          <!-- column 4 -->
          <div v-if="showManageButton || showActions">
            <div class="d-flex flex-row justify-content-end">
              <!-- view / manage -->
              <div v-if="showManageButton" class="mr-3">
                <b-button
                  variant="outline-primary"
                  class="button__view-manage"
                  @click="goToFeedPage()"
                >
                  View/Manage
                </b-button>
              </div>

              <!-- ellipsis -->
              <!-- <BaseEllipsis
                v-if="showActions && editable"
                :id="`ellipsis-${section.id}`"
                ref="ellipsis"
                class="icon__dropdown-menu"
                :disabled="
                  disabled ||
                    (isPassLastEnrollment && section.number_of_learners > 0)
                "
              >
                <b-dropdown-item
                  id="dropdown-item__edit"
                  class="dropdown-item__edit"
                  :disabled="isPassEndDate"
                  @click="goToEditSectionPage()"
                >
                  Edit
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    !(
                      section.number_of_learners > 0 ||
                      section.is_default ||
                      isPassEndDate
                    )
                  "
                  class="dropdown-item__delete"
                  @click="showModal(`modalDelete__${section.id}`)"
                >
                  Delete
                </b-dropdown-item>
              </BaseEllipsis>
              <b-tooltip
                v-if="isPassLastEnrollment && section.number_of_learners > 0"
                custom-class="ellipsis-tooltip"
                triggers="hover"
                :boundary-padding="10"
                :target="`ellipsis-${section.id}`"
              >
                <div>Session with enrolled learners</div>
                <div>and reached last enrollment date</div>
                <div>cannot be edited</div>
              </b-tooltip> -->
            </div>
          </div>
        </div>
      </div>

      <ModalDeleteSection
        :ref="`modalDelete__${section.id}`"
        :section="section"
        :title-time="{
          start_at: formatedDatetime(section.start_at, 'MMM D, YYYY hh:mma'),
          end_at: formatedDatetime(section.end_at, 'MMM D, YYYY hh:mma'),
          city_timezone: cityTimezone
        }"
      />
    </div>
  </div>
</template>

<script>
import { datetimeMixin } from '@/mixins/datetimeMixin';
// import BaseEllipsis from "@/components/base-components/BaseEllipsis";
// import MeetingSection from "./MeetingSection";
import ModalDeleteSection from './ModalDeleteSection';

export default {
  components: {
    // BaseEllipsis,
    ModalDeleteSection
    // MeetingSection,
  },

  mixins: [datetimeMixin],

  props: {
    /**
     * Recieving each section from Section tab
     */
    section: {
      type: Object,
      default: () => {}
    },

    /**
     * learning unit of this section
     */
    learningUnit: {
      type: Object,
      default: () => {}
    },

    /**
     * conflict list from /learning-unit/:id/post-schedule-conflict
     */
    conflict: {
      type: Boolean,
      default: false
    },

    showEnroll: {
      type: Boolean,
      default: true
    },

    showManageButton: {
      type: Boolean,
      default: true
    },

    showActions: {
      type: Boolean,
      default: true
    },

    showCode: {
      type: Boolean,
      default: true
    },

    showTimezone: {
      type: Boolean,
      default: false
    },

    editable: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: [Number, Boolean],
      default: false
    },

    feedRoute: {
      type: Object,
      default: () => ({})
    },

    colRow: {
      type: Number,
      default: 12
    },

    showTitleAsLink: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classRow() {
      return {
        [`col-${this.colRow}`]: true
      };
    },

    isPassEndDate() {
      /* equal to null cuz initted default section doesn't have date yet */
      if (this.section.end_at === null) {
        return false;
      } else {
        return new Date(this.section.end_at) < new Date();
      }
    },

    isPassLastEnrollment() {
      /* equal to null cuz initted default section doesn't have date yet */
      if (this.section.last_enrollment === null) {
        return false;
      } else {
        return new Date(this.section.last_enrollment) < new Date();
      }
    },

    enrollCount() {
      return `${this.section.number_of_learners ? this.section.number_of_learners : 0} / ${
        this.section.max_learners
      }
          `;
    },

    dateTimeStartToEnd() {
      return `${this.formatedDatetime(
        this.section.start_at,
        'MMM D, YYYY hh:mma'
      )} - ${this.formatedDatetime(this.section.end_at, 'MMM D, YYYY hh:mma')}`;
    },

    feedPageRoute() {
      return {
        ...this.feedRoute,
        query: {
          previousPath: this.$route.fullPath,
          view: 'feed',
          tab: 'posts'
        }
      };
    }
  },

  methods: {
    goToEditSectionPage() {
      this.$router.push({
        name: 'design-planning/section/edit',
        params: {
          sectionId: this.section.id,
          pageType: 'edit'
        },
        query: {
          previousPath: this.$route.fullPath
        }
      });
    },

    goToFeedPage() {
      this.$router.push({
        ...this.feedPageRoute
      });
    },

    goToPostList() {
      const query = {
        previousPath: this.$route.fullPath,
        view: 'list'
      };

      this.$router.push({
        ...this.feedRoute,
        query
      });
    },

    showModal(modalType) {
      this.$refs[modalType].show(modalType);
    }
  }
};
</script>

<style lang="scss" scoped>
.meeting {
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  align-items: flex-start;
  // flex-basis: 30%;

  &__week-day {
    align-self: flex-start;
    margin-bottom: 0.25rem;
  }

  &__circle-day {
    color: var(--gray-dark);
    background-color: var(--light);
    font-size: 0.65rem;
    font-weight: 600;
    padding: 0.4rem 0.65rem;
    border-radius: 50%;
    &:not(:last-child) {
      margin-right: 0.5rem;
    }
    &--active {
      color: var(--white);
      background-color: var(--primary);
    }
  }

  &__repeat-time {
    margin: 0.5rem 0;
  }

  &__detail {
    position: relative;
  }

  &__show-details {
    width: 6rem;
    color: var(--primary);
    cursor: pointer;
    // position: absolute;
    // top: 0;
    // left: 0;
    transition: all 0.3s;

    &:hover,
    &:active {
      transform: translateY(-1px);
    }
  }
}

.container__session {
  min-width: 75px;
}

.text__session-title {
  font-size: 12.16px;
  font-weight: bold;
  color: rgba(59, 62, 102, 0.3);
}

.text__session-id {
  font-size: 19px;
  font-weight: bold;
  color: #3b3e66;
}

.button__reschedule-post {
  color: #3c44b1;
  cursor: pointer;
}

.button__reschedule-session {
  color: #3c44b1;
  cursor: pointer;
}

.text__session-time {
  color: #3b3e66;
}

.button__set-session-time {
  font-size: 15.2px;
  color: #3c44b1;
  cursor: pointer;
}

.text__enrolled-slots {
  color: #3b3e66;
}

.ellipsis-tooltip::v-deep .tooltip-inner {
  max-width: none;
  width: 250px;
}
</style>
